import { getLastOrgId } from './prefStorage';

/**
 * The organization to select when a session is established: the one in the
 * URL when deep-linking under /$owner (so a window open on a different org
 * than the last-used one restores to what its URL says), otherwise the
 * persisted last-used organization. RhinoProvider validates the id against
 * the user's roles, so a stale value falls back to the first role — the same
 * org the $owner route redirects to for an unknown owner.
 */
export const getInitialBaseOwnerId = (): string | null => {
  const [first] = window.location.pathname.split('/').filter(Boolean);
  if (first && /^\d+$/.test(first)) return first;

  return getLastOrgId();
};
